<template>
  <component
    v-if="mcpComponent"
    :is="mcpComponent"
    :input="content.input ? JSON.parse(content.input) : null"
    :output="content.output ? JSON.parse(content.output) : null" />
</template>

<script>
import NtAiAssistantResponsePropertySearch from './responses/NtAiAssistantResponsePropertySearch.vue'

export default {
  components: {
    NtAiAssistantResponsePropertySearch
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    mcpComponent() {
      switch (this.content.name) {
        case 'property-search':
          return 'NtAiAssistantResponsePropertySearch'
        default:
          return null
      }
    }
  }
}
</script>
